import { IconCompass, IconHome, IconUsersGroup } from '@tabler/icons-react-native';
import { createTheme as createDSTheme } from 'app/shopify';

const theme = createDSTheme();

type LandingTab = 'home' | 'feed' | 'catalog';

export function LandingTabIcon({ active, tab }: { active: boolean; tab: LandingTab }) {
  const color = active ? theme.colors['text.inverse.primary'] : theme.colors['text.secondary'];
  const iconProps = { color, size: 18, strokeWidth: 1.8 };

  switch (tab) {
    case 'home':
      return <IconHome {...iconProps} />;
    case 'feed':
      return <IconUsersGroup {...iconProps} />;
    case 'catalog':
      return <IconCompass {...iconProps} />;
  }
}
